import type { HttpErrorResponse } from '@angular/common/http';

import type { PickActions } from '@core/ngrx-legacy';
import { createEntityCollectionStore, getEntityCollectionActions } from '@core/ngrx-legacy';
import type { PipelineTemplateListItem } from '@core/pipeline-templates-types';

const idSelector = ({ id }: { id: number }) => id;
const { actions, reducer, selectors, namespace } =
  createEntityCollectionStore<PipelineTemplateListItem>()('PipelineTemplateListItem', {
    idSelector,
    customActions: adapter => {
      const defaultActions = getEntityCollectionActions(adapter, idSelector);
      return {
        updatePositions: (state, payload: { ids: number[] }) =>
          defaultActions.fetchCollection(state),
        updatePositionsSuccess: (state, payload: { data: PipelineTemplateListItem[] }) =>
          defaultActions.fetchCollectionSuccess(state, payload),
        updatePositionsFailed: (state, payload: { error: HttpErrorResponse }) =>
          defaultActions.fetchCollectionFailed(state, payload),
      };
    },
  });

const PipelineTemplateListItemActions: PickActions<
  typeof actions,
  'fetchCollection' | 'updatePositions'
> = actions;

export {
  PipelineTemplateListItemActions,
  reducer as PipelineTemplateListItemReducer,
  selectors as PipelineTemplateListItemSelectors,
  namespace as PipelineTemplateListItemNamespace,
};
